/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Nov 22 2023
 **/

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { Row } from "@/frameworks/designStuff/components";

export const TextBannerWrapper = styled(Row)`
	display: inline-flex;
	background: ${({ theme }) => theme.colors.gradient_50_100};
	border-radius: 22px;
	padding: 8px 24px;
	text-wrap: nowrap;
`;

export const bannerCss = css`
	position: fixed;
	z-index: 10;
	top: 72px;
	left: 50%;
	transform: translateX(-50%);
`;
